import { createContext } from 'react';

/**
 * NavigateContext
 * - newTab(route, label?, event?)   -> open route in a new tab
 * - closeTab(value?)               -> close current or specific tab
 * - renameTab(value, newLabel)     -> rename an existing tab
 *
 * Default implementation is a full no-op so that components using this context
 * outside of <TabsHomePage> do not crash.
 */
export const NavigateContext = createContext({
  newTab: () => {},
  closeTab: () => {},
  renameTab: () => {},
});
